import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  GridView,
  CrudMasterDetailView,
  Widget,
  CompositeView,
  MasterDetailForm,
  FormInput,
  FormSelect,
  FormTextArea,
  FormSubmitButton,
  FormatText,
  CrudContext,
  ButtonDelete,
  useRouter,
} from '@digital/ui';
import { Diretoria, getAllDiretorias, createDiretoria, updateDiretoria, deleteDiretoria } from '@app/api/diretoria';
import { Usuario, getAllUsuariosPorPerfil } from '@app/api/usuario';
import { hasPermission } from '@app/helpers/permissions';

const validationSchema = Yup.object().shape({
  nome: Yup.string()
    .required('Nome requerido')
    .max(150, 'O nome deve ter no máximo 150 caracteres.'),
  sigla: Yup.string()
    .required('Sigla requerido')
    .max(5, 'A sigla deve ter no máximo 5 caracteres.'),
  descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
});

const DiretoriaComponent = () => {
  const { history } = useRouter();
  const [usuarios, setUsuarios] = useState<Usuario[]>();
  const [diretorias, setDiretorias] = useState(() => getAllDiretorias);

  useEffect(() => {
    const getUserData = async () => {
      const result = await getAllUsuariosPorPerfil(5);
      if (result) setUsuarios(result);
    };

    getUserData();
  }, []);

  const listarDiretorias = () => {
    setDiretorias(() => Promise.resolve(undefined));
    setDiretorias(() => getAllDiretorias);
  };

  const onCreateDiretoria = (diretoria: Diretoria) => {
    return createDiretoria(diretoria).then(resp => {
      if (resp.valid) listarDiretorias();
      return resp;
    });
  };

  const onUpdateDiretoria = (diretoria: Diretoria) => {
    return updateDiretoria(diretoria).then(resp => {
      if (resp.valid) listarDiretorias();
      return resp;
    });
  };

  const onDeleteDiretoria = (id: string) => {
    deleteDiretoria(id).then(resp => {
      if (resp.valid) listarDiretorias();
      history.push('/diretorias');
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={diretorias}
      createItem={hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR']) ? onCreateDiretoria : undefined}
      updateItem={hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR']) ? onUpdateDiretoria : undefined}
      icon="business-flow_chart"
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.sigla ? item.sigla.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      disableNotification
      titleExtractor={d => d.nome}
      detailTitleExtractor={x => `${x.sigla} - ${x.nome}`}
      descriptionExtractor={d => d.sigla || ''}>
      <CompositeView>
        {true && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              return (
                <GridView noform>
                  <MasterDetailForm validationSchema={validationSchema}>
                    <Widget
                      title="Dados de Diretoria"
                      actions={[
                        selectedItem && hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_DELETAR']) && (
                          <ButtonDelete
                            type="link"
                            confirm="Deseja realmente excluir este registro?"
                            okText="Confirmar"
                            onClick={() => onDeleteDiretoria(selectedItem.id)}
                          />
                        ),
                        hasPermission([
                          'DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR',
                          'DIRETORIA_AREA_DEPARTAMENTO_EDITAR',
                        ]) && (
                          <FormSubmitButton type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <FormInput label="Nome" name="nome" span={4} />
                      <FormInput label="Sigla" name="sigla" span={2} />
                      <FormSelect
                        showSearch
                        optionFilterProp="children"
                        label="Responsável"
                        name="usuarioResponsavelId"
                        options={usuarios && usuarios.map(a => ({ text: a.nome, value: a.id.toString() }))}
                        span={6}
                      />
                      <FormTextArea label="Descrição" placeholder="" name="descricao" rows={3} />
                    </Widget>
                  </MasterDetailForm>
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default DiretoriaComponent;
